import React, { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "./global/GlobalVars.js";
import { renderElement } from "./utils/render.js";

const ContentMobile = observer((props) => {
  //========================================================================
  // Status für Seitengröße und Skalierung
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [pageSize, setPageSize] = useState({ width: "100%", height: "0px" });
  const [scaleFactor, setScaleFactor] = useState(1);

  const HEADER_HEIGHT = 110;

  // Original-Entwurfsauflösung
  const ORIGINAL_WIDTH = 400;
  const ORIGINAL_HEIGHT = 750;
  const RATIO = ORIGINAL_WIDTH / ORIGINAL_HEIGHT; // ≈ 0.4909

  //========================================================================
  // Seitengröße und Skalierung anpassen
  useEffect(() => {
    const handleResize = () => {
      const availableHeight = window.innerHeight - HEADER_HEIGHT;
      const availableWidth = window.innerWidth;

      let pageWidth = availableHeight * RATIO;
      let pageHeight = availableHeight;

      if (pageWidth > availableWidth) {
        pageWidth = availableWidth;
        pageHeight = pageWidth / RATIO;
      }

      const newScaleFactor = pageWidth / ORIGINAL_WIDTH;
      setPageSize({ width: `${pageWidth}px`, height: `${pageHeight}px` });
      setWindowWidth(window.innerWidth);
      setScaleFactor(newScaleFactor);
      globalVars.setScaleFactor(newScaleFactor);
      globalVars.setPageSize({
        width: `${pageWidth}px`,
        height: `${pageHeight}px`,
      });
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //========================================================================
  // in die Mitte scrollen
  const contentRef = useRef(null);

  useEffect(() => {
    if (!contentRef.current) return;
    const raf1 = requestAnimationFrame(() => {
      const raf2 = requestAnimationFrame(() => {
        const el = contentRef.current;
        if (!el) return;

        const visibleWidth = window.innerWidth;
        const scrollLeft = (el.scrollWidth - visibleWidth) / 2;

        el.scrollTo({
          left: Math.max(0, scrollLeft),
          behavior: "auto",
        });
      });
      return () => cancelAnimationFrame(raf2);
    });

    return () => cancelAnimationFrame(raf1);
  }, [globalVars.pageProperties.currentPageConfig, scaleFactor]);

  // Noch nicht rendern wenn Seite noch nicht geladen
  if (globalVars.pageProperties.currentPageConfig.mobile === undefined) {
    return null;
  }

  return (
    // ########################################################################################################
    // ################################################ Content ###############################################
    // ########################################################################################################
    <>
      {globalVars.pageProperties.currentPageConfig.mobile === true ? (
        <div
          key={globalVars.pageProperties.actualPath + "-mobile"}
          className="content"
          style={{
            ...pageSize,
            position: "absolute",
            overflow: "hidden",
            left: (windowWidth - parseFloat(pageSize.width)) / 2,
          }}
        >
          {globalVars.pageProperties.currentPageConfig.elements?.map(
            (elementToRender, index) => (
              <div key={index}>
                {renderElement(elementToRender, scaleFactor, index)}
              </div>
            ),
          )}
        </div>
      ) : globalVars.pageProperties.currentPageConfig.mobile === false ? (
        <div
          key={globalVars.pageProperties.actualPath + "-desktop"}
          ref={contentRef}
          className="contentMobile"
          style={{
            ...pageSize,
            position: "absolute",
            overflowY: "hidden",
            overflowX: "scroll",
            width: window.innerWidth,
            left: 0,
          }}
        >
          <div
            style={{
              width: `calc(${globalVars.scaleFactor * 0.742574} * 1920px)`,
            }}
          >
            {globalVars.pageProperties.currentPageConfig.elements?.map(
              (elementToRender, index) => (
                <div key={index}>
                  {renderElement(
                    elementToRender,
                    scaleFactor * 0.742574,
                    index,
                  )}
                </div>
              ),
            )}
          </div>
        </div>
      ) : null}
    </>
  );
});

export default ContentMobile;
